import colors from './colors'
import { ArrowDropDownIcon } from './index'

export function componentsStyle(uiMode: 'dark' | 'light') {
  const _colors = colors(uiMode)
  return {
    MuiContainer: {
      styleOverrides: {
        root: ``,
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: `
        &.MuiCircularProgress-colorSecondary {
          color: ${_colors.white}
        }
        `,
      },
    },
    MuiTypography: {
      styleOverrides: {
        button: `
          text-transform: none
        `,
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: `
          span {
            ::before {
              background: ${_colors.white};
            }
          }
        `,
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: `
          padding-left: 24px;
          padding-right: 24px;
          border-radius: 0;
          height: 60px;
          width: 100%;
          color: ${_colors.white};
          font-weight: 400;
          box-sizing: border-box;
          border: 2px solid #565656;
          &:not(.Mui-disabled):hover {
            // 非禁用hover
            border-color: #ffffff !important;
          }
          input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          input[type="number"] {
              -moz-appearance: textfield;
          }
          input {
            box-sizing: border-box;
          }
          &.MuiOutlinedInput-root {
            padding: 0 !important;
          }
          &.placeholder-value {
            .MuiSelect-select {
              color: ${_colors.neutral[500]} !important;
            }
          }
          .MuiSelect-select {
            box-sizing: border-box;
            border: 0;
            outline-width: 0;
            color: #ffffff;
            font-weight: 600;
            font-size: 1rem;
            border-radius: 0px;
            padding: 0 24px !important;
            height: 100% !important;
            display: flex !important;
            align-items: center !important;
            .Mui-disabled {
              -webkit-text-fill-color: none !important;
            }
          }
          .MuiSelect-icon {
            right: 24px;
          }
          .MuiOutlinedInput-notchedOutline {
            border-width: 0!important;
          }
        `,
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: ArrowDropDownIcon,
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: `
          path {
            // fill: ${_colors.white};
            opacity: 1;
          }
        `,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: `
          border-radius: 0px;
        `,
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: `
          max-width: 100% !important;
        `,
        root: `
          .MuiBackdrop-root {
            background-color: rgba(3, 1, 27, 0)!important;
          }
          .MuiMenu-list {
            padding: 0;
          }
          .MuiMenuItem-root {
            font-weight: 700;
            font-size: 18px;
            justify-content: flex-start;
            padding: 16px 24px;
            &:hover {
              background-color: rgba(255, 255, 255, 0.1);
            }
          }
          .Mui-selected {
            background-color: ${_colors.neutral[500]}!important;
          }
        `,
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: `
          background: ${_colors.background.article};
        `,
      },
    },
    MuiSwitch: {
      styleOverrides: {
        thumb: `
          border-radius: 0;
          width: 16px;
          height: 16px;
          background: ${_colors.white};;
        `,
        switchBase: `
          padding: 4px;
          border-radius: 0;
        `,
        root: `
          width: 48px;
          height: 24px;
          padding: 0;
          .Mui-checked+.MuiSwitch-track {
            opacity: 1 !important;
            background: ${_colors.green[100]} !important;
          }
          .Mui-checked  {
            .MuiSwitch-thumb {
              background: ${_colors.white} !important;
            }
          }
        `,
        track: `
          width: 48px;
          height: 24px;
          padding: 4px;
          border-radius: 0;
          background: ${_colors.neutral[500]};
        `,
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeLarge: `
          font-size: 1.25rem;
        `,
        sizeMedium: `
          padding: 4px 28px;
        `,
        root: `
          min-height: 48px;
          padding: 7px 22px;
          box-shadow: none;
          text-transform: none;
          :hover {
            box-shadow: none;
          }
          &.Mui-disabled {
            color: ${_colors.white};
            opacity: 0.5;
          }
          &.MuiButton-outlinedPrimary {
            border: 2px solid ${_colors.white};
            font-weight: 700;
            font-family: 'Roboto Condensed', sans-serif;
            font-size: 20px;
            line-height: 20px;
            width: 100%;
          }
          &.MuiButton-containedPrimary {
            color: ${_colors.background.body}
          }
          &.MuiButton-containedPrimary:hover {
            background-color: ${_colors.white};
            color: ${_colors.background.body}
          }
          &.MuiButton-containedPrimary.Mui-disabled {
            opacity: 0.3;
            background-color: ${_colors.white};
            cursor: not-allowed!important;
          }
          // &.MuiButton-containedInfo {
          //   background-color: ${_colors.blue[1]};
          //   &:hover {
          //     opacity: 0.8;
          //   }
          // }
          &.MuiButton-containedSecondary.Mui-disabled {
            opacity: 0.3;
            cursor: not-allowed!important;
            color: ${_colors.white}!important;
            background-color: ${_colors.secondary};
          }
          &.MuiButton-containedPrimary:hover {
            opacity: 0.88;
          }
          &.MuiButton-containedSecondary:hover {
            background-color: ${_colors.secondary};
            opacity: 0.88;
          }
        `,
      },
    },
    MuiModal: {
      styleOverrides: {
        root: `
          .MuiBackdrop-root {
            background-color: rgba(18, 18, 18, 0.6);
          }
          > .MuiBox-root {
            outline: none;
            @media (max-width: 900px) {
              width: 100%;
              padding: 12px;
              height: 100%;
              overflow-y: auto;
            }
          }
        `,
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: `
          margin-bottom: 0px;
          border-radius: 0;
          color: #000;
        `,
        thumb: `
          border-radius: 0px;
          width: 8px;
        `,
        track: `
          height: 12px;
        `,
        mark: `
          display: none;
        `,
        rail: `
          opacity: 1;
          background: linear-gradient(
            to right,
            rgba(3, 1, 27, 0.2) 20%,
            rgba(3, 1, 27, 0.4) 20% 40%,
            rgba(3, 1, 27, 0.6) 40% 60%,
            rgba(3, 1, 27, 0.8) 60% 80%,
            rgba(3, 1, 27, 1) 80% 100%
          );
        `,
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: `
          border-color: ${_colors.grey[200]};
        `,
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: `
          z-index: 1300;
        `,
        paper: `
          max-width: 560px;
          background: ${_colors.background.article};
          color: ${_colors.white};
          overflow: initial;
          > .MuiBox-root {
            color: ${_colors.white};
          }
        `,
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: `
          background: ${_colors.background.article};
          color: ${_colors.white};
          padding: 32px;
          font-size: 2rem;
          line-height: 2.5rem;
          font-family: 'Roboto Condensed', sans-serif;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: space-between;
        `,
      },
    },
    MuiTab: {
      styleOverrides: {
        root: `
          text-transform: none
        `,
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: `
          background: ${_colors.secondary};
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
          padding: 16px;
          max-width: fit-content;
          &.MuiTooltip-tooltipArrow {
          }
        `,
        arrow: `
          color: ${_colors.secondary};
        `,
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: `
          border-top: 1px solid #323232;
          background: #202020;
          &::before {
            display: none;
          }
          box-shadow: none;
          &.Mui-expanded,
          .Mui-expanded {
            margin: 0 !important;
          }
          .MuiAccordionSummary-root {
            min-height: 72px !important;
            padding: 0 32px 0 40px;
          }
          .MuiAccordionDetails-root {
            background: #161616;
          }
        `,
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: `
          color: #5b5b5b;
          .MuiSvgIcon-root {
            width: 1.25rem;
            height: 1.25rem;
          }
        `,
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: `
          background-color: #202020;
          transform: scale(1);
          ::after {
            background: linear-gradient(90deg, transparent, rgb(0 0 0 / 51%), transparent);
          }
        `,
      },
    },
  }
}
